export const extractProjectsSummaryInfos = (projectsData = []) => {
  const stats = { totalCost: 0 };
  if (!projectsData?.length > 0) {
    return stats;
  }

  return projectsData.reduce((accumulator, { estimated_total_cost }) => {
    accumulator.totalCost += estimated_total_cost ?? 0;
    return accumulator;
  }, stats);
};
